import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsAboutLazy = loadable(() => import(/* webpackChunkName: "SettingsLight" */ './SettingsAboutSuspense'));

export const SettingsAboutAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsAboutLazy />
    </DelayedSuspense>
);
